import {
  breakpointSizes,
  getBreakpointOnly,
  styleConstants,
} from '@paywithextend/components'
import { base_colorAction } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
  width: 100%;

  .Subnav {
    padding-left: 0;
    padding-right: 0;
  }

  &.FamilyLayout-alignWithHeader {
    .Subnav {
      background-color: ${styleConstants.colors.white};
      padding-left: ${styleConstants.widths.headerPaddingXLGUp};
      padding-right: ${styleConstants.widths.headerPaddingXLGUp};

      ${getBreakpointOnly(breakpointSizes.XXSM)(css`
        padding-left: ${styleConstants.widths.headerPaddingXXSMOnly};
        padding-right: ${styleConstants.widths.headerPaddingXXSMOnly};
      `)}
      ${getBreakpointOnly(breakpointSizes.XSM)(css`
        padding-left: ${styleConstants.widths.headerPaddingXSMOnly};
        padding-right: ${styleConstants.widths.headerPaddingXSMOnly};
      `)}
      ${getBreakpointOnly(breakpointSizes.SM)(css`
        padding-left: ${styleConstants.widths.headerPaddingSMOnly};
        padding-right: ${styleConstants.widths.headerPaddingSMOnly};
      `)}
      ${getBreakpointOnly(breakpointSizes.MD)(css`
        padding-left: ${styleConstants.widths.headerPaddingMDOnly};
        padding-right: ${styleConstants.widths.headerPaddingMDOnly};
      `)}
      ${getBreakpointOnly(breakpointSizes.LG)(css`
        padding-left: ${styleConstants.widths.headerPaddingLGOnly};
        padding-right: ${styleConstants.widths.headerPaddingLGOnly};
      `)}
    }
  }

  /*
    Each tab's clickable target is an <a> (rendered via Lnk) that fills the
    ext-ui Tab so the whole tab is keyboard- and pointer-operable. It inherits
    the Tab's colour so the secondary/active/hover colour transitions defined in
    Tab.style continue to apply.
  */
  .FamilyLayout-tabLink {
    display: flex;
    align-items: center;
    gap: 4px;
    color: inherit;
    text-decoration: none;
  }

  .FamilyLayout-tabLink:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: 2px;
    border-radius: 2px;
  }

  /*
    Respect prefers-reduced-motion: the sliding active-bar (.Subnav-activeBar)
    animates left/width via a transition declared in ext-ui Subnav.style. Disable
    that motion for users who opt out; the bar still moves, it just doesn't slide.
    !important guarantees this wins over the Subnav transition regardless of
    style-injection order.
  */
  @media (prefers-reduced-motion: reduce) {
    .Subnav-activeBar {
      transition: none !important;
    }
  }
`
